'use client'

import type { DbAttachment } from '../Attachments/types'
import { FullscreenMarkdownEditor } from '../FullscreenMarkdownEditor'

export type MarkdownAndAttachmentsValue = {
  markdown: { id?: string; content: string }
  attachments?: DbAttachment[]
}

type MarkdownAndAttachmentsProps = {
  value: MarkdownAndAttachmentsValue | undefined
  onChange: (next: MarkdownAndAttachmentsValue) => void
  height?: number
  singleView?: boolean
  markdownOnly?: boolean
  disabled?: boolean
  defaultMarkdownContent?: string
  preserveMarkdownId?: boolean
  onContentChange?: (markdown: string) => void
  localStorageEnabled?: boolean
}

export function MarkdownAndAttachments({
  value,
  onChange,
  height,
  singleView = false,
  markdownOnly,
  disabled,
  defaultMarkdownContent = '',
  preserveMarkdownId = true,
  onContentChange,
  localStorageEnabled = false
}: MarkdownAndAttachmentsProps) {
  const editorValue = {
    markdown: value?.markdown?.content ?? defaultMarkdownContent,
    attachments: value?.attachments ?? []
  }

  return (
    <FullscreenMarkdownEditor
      height={height}
      singleView={singleView}
      markdownOnly={markdownOnly}
      disabled={disabled}
      localStorageEnabled={localStorageEnabled}
      value={editorValue}
      onChange={next => {
        const nextMarkdown: MarkdownAndAttachmentsValue['markdown'] = {
          content: next.markdown
        }
        if (preserveMarkdownId && value?.markdown?.id) {
          nextMarkdown.id = value.markdown.id
        }
        onChange({
          markdown: nextMarkdown,
          attachments: next.attachments ?? []
        })
        onContentChange?.(next.markdown)
      }}
    />
  )
}
